module.exports = "<mat-card fxFlex=\"1 1 auto\" ngClass=\"app-card\">\n  <p *ngIf=\"errorMessage | async\">{{ errorMessage | async }}</p>\n</mat-card>"